import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-legal-footer',
  standalone: true,
  imports: [],
  template: `
    <footer class="legal-footer">
      <div class="legal-links sign-in-links">
        <a
          href="https://www.ross-robotics.co.uk/information-security-management"
          target="_blank"
          rel="noopener noreferrer"
          class="legal-link"
        >
          Information Security
        </a>
        <span class="separator">|</span>
        <a
          href="https://www.ross-robotics.co.uk/quality-management"
          target="_blank"
          rel="noopener noreferrer"
          class="legal-link"
        >
          Quality Management
        </a>
      </div>

      <p class="copyright">{{ productName }} &copy; {{ companyName }} {{ year }}</p>
    </footer>
  `,
  styles: [`
    .legal-footer {
      text-align: center;
      color: var(--aida-colour-text-secondary);
      font-family: var(--aida-ref-font-family-text);
    }

    .legal-links {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: var(--aida-ref-spacing-50);
      margin-bottom: var(--aida-ref-spacing-50);
    }

    .legal-link {
      font-size: var(--aida-ref-font-size-200);
      color: var(--aida-colour-text-secondary);
      text-decoration: none;
      opacity: 0.9;
    }

    .legal-link:hover {
      color: var(--aida-colour-text-primary);
      text-decoration: underline;
      opacity: 1;
    }

    .separator {
      font-size: var(--aida-ref-font-size-200);
      color: var(--aida-colour-text-secondary);
      opacity: 0.8;
    }

    .copyright {
      margin: 0;
      font-size: var(--aida-ref-font-size-200);
      color: var(--aida-colour-text-secondary);
      opacity: 0.9;
    }

    @media (max-width: 600px) {
      .legal-links {
        flex-direction: column;
        gap: var(--aida-ref-spacing-50);
      }

      .separator {
        display: none;
      }
    }
  `],
})
export class LegalFooterComponent {
  @Input() productName = 'AIDA';
  @Input() companyName = 'Ross Robotics';
  @Input() year = new Date().getFullYear();
}
